class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');

      // Update ATC button states based on current cart quantity
      if (typeof cartLimitReached === 'function') {
        cartLimitReached();
      }
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, isFromBundleBuilder, productsIdList) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    //qty calc

    // Read from the updated header cart bubble
    const headerCartBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    let qty = headerCartBubble ? headerCartBubble.dataset.items : 0;

    const isOnBundlePage = document.querySelector('.bundle-builder__wrapper') !== null;
    const lastItem = parsedState.items && parsedState.items.length > 0 ? parsedState.items[parsedState.items.length - 1] : null;
    const justAddedFreeProduct = lastItem?.properties?._dsrFree === 'true';
    const isMobile = window.innerWidth < 991;

    // Skip on cart page
    if (window.location.href.includes('cart')) {
      console.log("product added din cart page")
      return;
    }

    // Bundle builder - don't open drawer
    if (isFromBundleBuilder || (isOnBundlePage && justAddedFreeProduct)) {
      console.log('added item from bundle builder')
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      });
      showDynamicPrices();
      return;
    }

    // Mobile: show toast notification (defer if modal opens)
    if (isMobile) {
      // Fetch cart to check if modal will open
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => {
          let cartQty = 0;
          let cartHasFreeProduct = false;

          data.items.forEach(item => {
            if (item.handle !== 'navidium-shipping-protection' && item.properties?._dsrFree !== 'true') {
              cartQty += item.quantity;
            }
            if (item.properties?._dsrFree === 'true') {
              cartHasFreeProduct = true;
            }
          });

          const hasPickedBefore = sessionStorage.getItem('freeProductPickedBefore');
          const modalWillOpen = cartQty == 6 && !cartHasFreeProduct && hasPickedBefore !== 'true';

          if (modalWillOpen) {
            // Modal will open - defer toast until modal closes
            sessionStorage.setItem('showToastAfterModalClose', 'true');
          } else {
            // Modal won't open - show toast now
            if (typeof window.showCartToast === 'function') {
              window.showCartToast();
            }
          }
        });
    }
    else {
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    }

    // Update bottom island cart count for mobile
    updateCartCountBubbleBottomIsland(parsedState.item_count);

    // Update bundle builder if on bundle page
    if (typeof updateBundleBuilder === 'function') {
      updateBundleBuilder();
    }

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


